import { render } from "./LegoStepDelivery.vue?vue&type=template&id=0bab5e64"
import script from "./LegoStepDelivery.vue?vue&type=script&lang=js"
export * from "./LegoStepDelivery.vue?vue&type=script&lang=js"
script.render = render

export default script